module.exports = __webpack_public_path__ + "img/Logo.58534080.svg";